module.exports = __webpack_public_path__ + "img/04—01—02—Local IP phone credentials > Inline Edit > Show Password > Excellent.60a1e155.jpg";